import { createSlice } from '@reduxjs/toolkit'

export const racingPageSlice = createSlice({
  name: 'racingPage',
  initialState: [],
  reducers: {
    getRacingPageDataSuccess: (state, action) => action.payload,
    getRacingPageError: (state) => state,
  },
})

export const {getRacingPageDataSuccess, getRacingPageError } = racingPageSlice.actions

export default racingPageSlice.reducer
